// extracted by mini-css-extract-plugin
export default {"container":"BookmarkDetail_container__mSUe9"};